import { useEffect, useState } from "react";
import { wfAPI } from "./wfApi";
import { toast } from "sonner";

export default function Approvals() {
  const [items, setItems] = useState([]);
  useEffect(() => { wfAPI.approvalHierarchies().then(setItems).catch((e) => toast.error(e?.response?.data?.detail || "Failed")); }, []);

  return (
    <div className="space-y-4" data-testid="wf-approvals">
      <div>
        <h2 className="font-display text-[18px] font-semibold text-hocp-navy">Approval Hierarchies</h2>
        <p className="text-[12.5px] text-slate-500">Per-domain chains consumed by the Approval Engine. Delegation-aware routing.</p>
      </div>
      {items.length === 0 ? (
        <div className="bg-white border border-slate-200 rounded-2xl p-10 text-center text-slate-400 text-[13px]">
          No hierarchies configured. Set up per-domain chains via <code>PUT /wf/v1/approvals/hierarchy</code>.
        </div>
      ) : (
        <div className="space-y-3">
          {items.map((h) => (
            <div key={h.id} data-testid={`hierarchy-${h.domain}`} className="bg-white border border-slate-200 rounded-2xl p-4">
              <div className="text-[13px] font-medium text-hocp-navy mb-2">{h.domain}</div>
              <div className="flex flex-wrap gap-1.5">
                {(h.steps || []).map((s, i) => (
                  <span key={i} className="px-2 py-0.5 text-[11.5px] rounded-md bg-slate-100 text-slate-600">
                    {i+1}. {s.role_template_id || s.role_template_code || JSON.stringify(s)}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
